module.exports = __webpack_public_path__ + "static/media/mapa_mental.8b7d9f18.jpg";